module.exports = __webpack_public_path__ + "static/media/house_large_bg.b1c39df9.jpg";